import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { RolesService } from '../services/roles.service';
import { SystemRole } from '../models/roles';
import { Subscription } from 'rxjs';

@Directive({ selector: '[appHasRole]' })
export class HasRoleDirective {
  private rolesSub?: Subscription;
  private requiredRoles: SystemRole[] = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private rolesService: RolesService
  ) {
    this.rolesSub = this.rolesService.roles.subscribe(userRoles => {
      this.updateView(userRoles);
    });
  }

  @Input() set appHasRole(role: SystemRole | SystemRole[]) {
    this.requiredRoles = Array.isArray(role) ? role : [role];
    this.updateView(this.rolesService.roles.getValue());
  }

  private updateView(userRoles: SystemRole[]) {
    this.viewContainer.clear();

    if (this.requiredRoles.some(r => userRoles.includes(r))) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  ngOnDestroy() {
    this.rolesSub?.unsubscribe();
  }
}